<template>
  <div class="teaching-template-page">
    <el-card class="tt-header">
      <el-button type="text" icon="el-icon-arrow-left" @click="$emit('switch-view', 'MemberCenter')" style="margin-bottom:10px;">
        返回会员中心
      </el-button>
      <div class="tt-header-row">
        <el-select v-model="category" placeholder="全部分类" class="tt-select" @change="fetchData">
          <el-option label="全部分类" value="" />
          <el-option v-for="cat in categories" :key="cat" :label="cat" :value="cat" />
        </el-select>
      </div>
    </el-card>
    <el-card class="tt-list-card">
      <el-row :gutter="18">
        <el-col :xs="24" :sm="12" :md="8" v-for="tpl in templateList" :key="tpl.id">
          <el-card class="tt-item">
            <el-image :src="tpl.img" class="tt-img" fit="cover" />
            <div class="tt-info">
              <div class="tt-title">{{ tpl.title }}</div>
              <div class="tt-desc">{{ tpl.desc }}</div>
              <div class="tt-btns">
                <el-button size="mini" @click="preview(tpl)">预览</el-button>
                <el-button size="mini" type="primary" @click="download(tpl)">下载</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        @current-change="fetchData"
        class="tt-pagination"
      />
    </el-card>
    <el-dialog :visible.sync="showPreview" width="60%" :title="previewTpl.title">
      <el-image :src="previewTpl.img" style="width:100%" fit="contain" />
      <div style="margin-top: 16px;">{{ previewTpl.desc }}</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TeachingTemplate',
  data() {
    return {
      category: '',
      categories: ['动物套件', '文创产品', '建筑套件', '卡通人物'],
      templateList: [],
      page: 1,
      pageSize: 6,
      total: 0,
      showPreview: false,
      previewTpl: {},
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      // 与激光切割机相关的文创课程模板示例
      const all = [
        { id: 1, img: '/img/his1.jpg', title: '激光切割机动物拼装教学模板', desc: '动物拼装套件教学用', type: '动物套件' },
        { id: 2, img: '/img/his2.jpg', title: '激光切割机文创钥匙扣教学模板', desc: '钥匙扣文创产品教学', type: '文创产品' },
        { id: 3, img: '/img/his3.jpg', title: '激光切割机建筑模型教学模板', desc: '建筑模型套件教学', type: '建筑套件' },
        { id: 4, img: '/img/his4.jpg', title: '激光切割机卡通人物拼装模板', desc: '卡通人物拼装教学', type: '卡通人物' },
        { id: 5, img: '/img/his5.jpg', title: '激光切割机创意灯具教学模板', desc: '灯具文创产品教学', type: '文创产品' },
        { id: 6, img: '/img/his6.jpg', title: '激光切割机动物面具教学模板', desc: '动物面具套件教学', type: '动物套件' },
        { id: 7, img: '/img/his7.jpg', title: '激光切割机创意台历教学模板', desc: '台历文创产品教学', type: '文创产品' },
      ];
      let filtered = all.filter(item => !this.category || item.type === this.category);
      this.total = filtered.length;
      const start = (this.page - 1) * this.pageSize;
      this.templateList = filtered.slice(start, start + this.pageSize);
    },
    preview(tpl) {
      this.previewTpl = tpl;
      this.showPreview = true;
    },
    download(tpl) {
      this.$message.success(`正在下载：${tpl.title}`);
      // 生产环境可用真实下载接口
    },
  }
};
</script>

<style scoped>
.teaching-template-page {
  max-width: 1050px;
  margin: 0 auto;
  padding: 32px 0;
}
.tt-header {
  margin-bottom: 18px;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
}
.tt-header-row {
  display: flex;
  align-items: center;
  gap: 18px;
}
.tt-select {
  width: 180px;
}
.tt-list-card {
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
  margin-bottom: 18px;
}
.tt-item {
  display: flex;
  gap: 16px;
  border-radius: 8px;
  margin-bottom: 18px;
  min-height: 120px;
  padding-left: 35px;
}
.tt-img {
  width: 96px;
  height: 96px;
  border-radius: 8px;
  object-fit: cover;
}
.tt-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.tt-title {
  font-size: 16px;
  font-weight: 500;
}
.tt-desc {
  font-size: 13px;
  color: #888;
  margin: 8px 0;
}
.tt-btns {
  display: flex;
  gap: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tt-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
